import { useContext, useState } from "react";
import { WorkflowContext } from "../contexts";
import ToggleButton from "./ToggleButton";
import WorkflowAutomationPanelManual from "./WorkflowAutomationPanelManual";
import SmallTextInputField from "./SmallTextInputField";
import SmallSelectField from "./SmallSelectField";
import { convertToRange } from "../utils";
import { useTranslation } from "react-i18next";

function WorkflowAutomationPanelForms() {
  const { t } = useTranslation();
  const { workflow, automationOptions, updateAutoCreate, updateAutomationOptions } = useContext(WorkflowContext);

  const [automationIsActive, setAutomationIsActive] = useState(false);

  function handleChangeRange(value: string) {
    updateAutomationOptions({ range: convertToRange(value) });
  }

  return (
    <>
      {/* Primary Actions - Run Workflow */}
      <div className="flex flex-col gap-2 select-none">
        <div className="group flex items-center gap-1 font-gilroy font-semibold text-sm">
          {t("Run Workflow")}
        </div>

        <div className="flex items-center justify-between text-sm w-full gap-2">
          <div className="flex-shrink-0">{t("Run workflow for")}</div>
          <SmallSelectField value={automationOptions.mode} onChange={(mode) => updateAutomationOptions({ mode })} className="w-full" disabled={automationIsActive}>
            <option value="ALL">{t("all data")}</option>
            <option value="CUSTOM">{t("custom range")}</option>
          </SmallSelectField>
        </div>

        {(automationOptions.mode === "CUSTOM") &&
          <div className="flex text-sm w-full items-center justify-between">
            <SmallTextInputField label={t("Response Range")} className="w-full" placeholder="e.g. 1-5, 8, 10+" value={automationOptions.range ?? ""} onChange={handleChangeRange} autoFocus invalid={!automationOptions.range} disabled={automationIsActive} />
          </div>
        }

        <WorkflowAutomationPanelManual disabled={automationOptions.mode === "CUSTOM" && !automationOptions.range} setIsActive={setAutomationIsActive} />
      </div>

      <div className="flex items-center gap-2 my-2">
        <div className="h-px bg-gray-400 w-full" />
        <div className="flex-shrink-0 font-gilroy font-semibold text-xs text-gray-600">{t("or")}</div>
        <div className="h-px bg-gray-400 w-full" />
      </div>

      {/* Auto-Create Section */}
      <div className="flex flex-col gap-2">
        <div className="flex justify-between font-gilroy font-semibold text-sm">
          {t("Auto-Create")}
          <ToggleButton value={workflow.autoCreate} onChange={updateAutoCreate} bgColor="bg-green" />
        </div>

        <div className="text-xs text-gray-600">
          {t("Portant will run this workflow whenever a new response is submitted to the form.")}
        </div>
      </div>
    </>
  );

}

export default WorkflowAutomationPanelForms;
